import { combineReducers } from "redux";
import { Data_Section, Initial_Register, LogOut ,Socket } from "./constants";

const Initial_State = {
  User: {
    token: "",
    payload: null,
  },
  Socket: {
    connected: false,
    data : {},
    otp : ""
  }
};

function LoginReducer(state = Initial_State, action) {
  switch (action.type) {
    case Data_Section:
      return {
        ...state,
        ...action.Register_Section,
      };
    case Socket:
      return {
        ...state,
        ...action.Socket
      }
    case LogOut:
      return Initial_State;
    default:
      return Initial_State;
  }
}

const JamskeApp = combineReducers({ LoginReducer: LoginReducer });

export default JamskeApp;
